import api from '../../utils/api';
import apiformData from '../../utils/apiformData'
import {
    LOGIN,
    LOGOUT,
    GET_AUTH_USER,
    RESET_PASSWORD,
    UPDATE_AUTH_USER,
    GET_AUTH_PERMISSION,

} from '../types';
import { setCookie, removeCookie } from '../../utils/cookie';
import { NotificationManager } from 'react-notifications';

export const login = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/auth/login', data).then(res => {
            // var checkrole = res.data.data.customer.roles.filter(item => item.id === 5)
            // if (checkrole.length) {

            if (res.data.data.user.roles === 'super' || res.data.data.user.roles === "admin") {
                setCookie('token', res.data.access_token, 14);
                dispatch({ type: LOGIN, payload: res.data.data });
                resolve(true)
            }
            else {

                NotificationManager.error('You are not authorised to access');
                resolve(true)
            }
        }).catch(error => {


            if (error && (error.data.statusCode === 401 || error.data.statusCode === 470)) {

                NotificationManager.error('Incorrect email or password');

            }
            //TODO process new status code if getting it here

            reject(error);
        })
    })
}

export const getAuthUser = () => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/auth/loginToken').then(res => {

            dispatch({ type: GET_AUTH_USER, payload: res.data.data });
            resolve(true)
        }).catch(err => {
            NotificationManager.error("Some thing went wrong, please try again!");
            reject(err);
        })
    })
}

export const updateAuthUser = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/client/account/updateProfile', data).then(res => {
            dispatch({ type: UPDATE_AUTH_USER, payload: res.data.data });
            console.log('res', res);
            NotificationManager.success("Cập nhật thành công!");
            resolve(true)
        }).catch(err => {
            console.log(err.response)
            NotificationManager.error("Some thing went wrong, please try again!");
            reject(err);
        })
    })
}

export const changePassword = (data) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.post('/auth/password', data);

            resolve(true);
        } catch (err) {
            reject(err);
        }
    })
}

export const resetPassword = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/reset-password', data).then(res => {
            dispatch({ type: RESET_PASSWORD, payload: res.data.data });
            resolve(true)
        }).catch(err => {
            console.log(err);
            let message = "Some thing went wrong, please try again!";
            if (err.response.data.msg) message = err.response.data.msg;
            NotificationManager.error(message);
            reject(err);
        })
    })
}

export const logout = () => dispatch => {
    return new Promise((resolve, reject) => {
        removeCookie('token');
        dispatch({ type: LOGOUT });
        resolve(true);
    })
}

export const getAuthPermission = () => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/permission/get_all_permission_of_user').then(res => {
            dispatch({ type: GET_AUTH_PERMISSION, payload: res.data });
            resolve(true)
        }).catch(err => {
            console.log(err.response);
            reject(err);
        })
    })
}
export const updateAvatar = (data) => dispatch => {

    return new Promise((resolve, reject) => {
        apiformData
            .post('/client/account/updateAvatar', data)
            .then(res => {
                resolve(res.data);
                console.log(res.data)

            })
            .catch(error => {
                reject(error.response);
            })
    })
}
